import {
    Alert,
    AlertIcon,
    Box,
    Grid,
    Heading,
    Icon,
    Spinner,
    Table,
    Tbody,
    Td,
    Text,
    Th,
    Thead,
    Tr,
    VStack
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { FaCalendarAlt, FaCheckCircle, FaClock, FaTruck } from 'react-icons/fa';
import { fetchOrdersWidgets } from '../../api';
import { hasPermission } from '../../Utils';

const StatCard = ({ icon, title, value, color }) => (
    <Box
        bg={color + ".100"}
        p={5}
        borderRadius="xl"
        boxShadow="sm"
        textAlign="center"
        minW={"120px"}
    >
        <Icon as={icon} boxSize={8} mb={2} color={color + ".600"} />
        <Text fontWeight="bold" fontSize="md" mb={1}>{title}</Text>
        <Text fontSize="2xl" fontWeight="semibold" color={color + ".800"}>{value}</Text>
    </Box>
);

const DataTable = ({ icon, title, columns, rows }) => (
    <Box
        p={5}
        borderRadius="xl"
        boxShadow="md"
        bg="white"
        overflowX="auto"
    >
        <Heading size="md" mb={3} display="flex" alignItems="center" gap={2}>
            <Icon as={icon} />
            {title}
        </Heading>
        {rows.length ? (
            <Table size="sm" variant="striped" colorScheme="gray">
                <Thead>
                    <Tr>
                        {columns.map((col, i) => (
                            <Th key={i} isNumeric={col.numeric}>{col.label}</Th>
                        ))}
                    </Tr>
                </Thead>
                <Tbody>
                    {rows.map((row, i) => (
                        <Tr key={i}>
                            {columns.map((col, ci) => (
                                <Td key={ci} isNumeric={col.numeric}>{row[col.key]}</Td>
                            ))}
                        </Tr>
                    ))}
                </Tbody>
            </Table>
        ) : (
            <Text fontSize="sm" color="gray.500">No data available.</Text>
        )}
    </Box>
);

const ClientsOrdersWidgets = () => {
    const [ongoingOrders, setOngoingOrders] = useState(0);
    const [finishedOrders, setFinishedOrders] = useState(0);
    const [monthlyOrders, setMonthlyOrders] = useState(0);
    // const [topItems, setTopItems] = useState([]);
    // const [topFacilities, setTopFacilities] = useState([]);
    const [averageFinishingTime, setAverageFinishingTime] = useState("N/A");
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!hasPermission("clientOrderWidget")) return;

        const load = async () => {
            try {
                const res = await fetchOrdersWidgets();
                if (res.success) {
                    setOngoingOrders(res.data.ongoingOrders);
                    setFinishedOrders(res.data.finishedOrders);
                    setMonthlyOrders(res.data.monthlyOrders);
                    // setTopItems(res.data.topItems || []);
                    // setTopFacilities(res.data.topFacilities || []);
                    setAverageFinishingTime(res.data.averageFinishingTime || "N/A");
                } else {
                    setError(res.message);
                }
            } catch {
                setError("Failed to load data.");
            }
            setLoading(false);
        };

        load();
    }, []);

    const stats = [
        { icon: FaTruck, title: "Ongoing", value: ongoingOrders, color: "blue" },
        { icon: FaCheckCircle, title: "Finished", value: finishedOrders, color: "green" },
        { icon: FaCalendarAlt, title: "Monthly", value: monthlyOrders, color: "purple" },
        { icon: FaClock, title: "Avg Time", value: averageFinishingTime !== "N/A" ? `${averageFinishingTime} hrs` : "N/A", color: "orange" }
    ];

    if (!hasPermission("clientOrderWidget")) return null;

    return (
        <Box w="full">
            {loading ? (
                <Box py={10} textAlign="center"><Spinner size="lg" /></Box>
            ) : error ? (
                <Alert status="error"><AlertIcon />{error}</Alert>
            ) : (
                <VStack align="stretch" spacing={8}>
                    <Heading size="md">📦 Clients Orders Overview</Heading>

                    <Grid
                        templateColumns={{ base: "repeat(1, 1fr)", sm: "repeat(2, 1fr)", xl: "repeat(4, 1fr)" }}
                        gap={6}
                    >
                        {stats.map((s, i) => (
                            <StatCard key={i} {...s} />
                        ))}
                    </Grid>

                    {/* <Grid templateColumns={{ base: "1fr", lg: "1fr 1fr" }} gap={8}>
                        <DataTable
                            icon={FaBuilding}
                            title="Top 3 Facilities"
                            columns={[
                                { label: "Name", key: "facilityName" },
                                { label: "Requested", key: "totalRequested", numeric: true },
                                { label: "Sent", key: "totalSent", numeric: true },
                            ]}
                            rows={topFacilities}
                        />

                        <DataTable
                            icon={FaBoxOpen}
                            title="Top 3 Items"
                            columns={[
                                { label: "Name", key: "itemName" },
                                { label: "Requested", key: "totalRequested", numeric: true },
                                { label: "Sent", key: "totalSent", numeric: true },
                            ]}
                            rows={topItems}
                        />
                    </Grid> */}
                </VStack>
            )}
        </Box>
    );
};

export default ClientsOrdersWidgets;
